// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.empattendancewidget-inline-1 {
  display: flex;
  justify-content: center;
  margin-bottom: 12px;
}

.empattendancewidget-inline-2 {
  font-weight: 700;
  font-size: 15px;
}

.empattendancewidget-inline-3 {
  padding: 0;
}

.empattendancewidget-inline-4 {
  font-weight: 600;
}

.empattendancewidget-inline-5 {
  color: #64748b;
}

.empattendancewidget-inline-6 {
  padding: 0;
}

.empattendancewidget-inline-7 {
  font-weight: 600;
}

.empattendancewidget-inline-8 {
  color: #64748b;
}

.empattendancewidget-dyn-1 {
  color: var(--empattendancewidget-1-color);
}

.empattendancewidget-dyn-2 {
  color: var(--empattendancewidget-2-color);
  font-weight: 700;
}

.empattendancewidget-dyn-3 {
  width: var(--empattendancewidget-3-width);
  background: var(--empattendancewidget-3-background);
}

.empattendancewidget-dyn-4 {
  background: var(--empattendancewidget-4-background);
}

.empattendancewidget-dyn-5 {
  background: var(--empattendancewidget-5-background);
  color: var(--empattendancewidget-5-color);
}
`, "",{"version":3,"sources":["webpack://./src/assets/styles/Employee/EmpAttendanceWidget.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,yCAAyC;EACzC,gBAAgB;AAClB;;AAEA;EACE,yCAAyC;EACzC,mDAAmD;AACrD;;AAEA;EACE,mDAAmD;AACrD;;AAEA;EACE,mDAAmD;EACnD,yCAAyC;AAC3C","sourcesContent":[".empattendancewidget-inline-1 {\n  display: flex;\n  justify-content: center;\n  margin-bottom: 12px;\n}\n\n.empattendancewidget-inline-2 {\n  font-weight: 700;\n  font-size: 15px;\n}\n\n.empattendancewidget-inline-3 {\n  padding: 0;\n}\n\n.empattendancewidget-inline-4 {\n  font-weight: 600;\n}\n\n.empattendancewidget-inline-5 {\n  color: #64748b;\n}\n\n.empattendancewidget-inline-6 {\n  padding: 0;\n}\n\n.empattendancewidget-inline-7 {\n  font-weight: 600;\n}\n\n.empattendancewidget-inline-8 {\n  color: #64748b;\n}\n\n.empattendancewidget-dyn-1 {\n  color: var(--empattendancewidget-1-color);\n}\n\n.empattendancewidget-dyn-2 {\n  color: var(--empattendancewidget-2-color);\n  font-weight: 700;\n}\n\n.empattendancewidget-dyn-3 {\n  width: var(--empattendancewidget-3-width);\n  background: var(--empattendancewidget-3-background);\n}\n\n.empattendancewidget-dyn-4 {\n  background: var(--empattendancewidget-4-background);\n}\n\n.empattendancewidget-dyn-5 {\n  background: var(--empattendancewidget-5-background);\n  color: var(--empattendancewidget-5-color);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
